<template>
  <div class="item-image-slider mb-4">
    <img
      :src="selectedImage.imageUrl"
      class="d-block mw-350 m-a"
      @click="fullScreenGalleryIndex = galleryIndex"
    />

    <gallery
      :images="slides"
      :index="fullScreenGalleryIndex"
      @close="fullScreenGalleryIndex = null"
    ></gallery>
    <div v-if="images.length > 1" class="gallery-controls">
      <div class="gallery-image-previous" @click="gallerySlide(-1)">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div class="gallery-image-next" @click="gallerySlide(1)">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Gallery from "vue-gallery"
import "@splidejs/splide/dist/css/themes/splide-default.min.css"

export default {
  components: {
    Gallery,
  },
  props: {
    images: {
      required: true,
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data: function () {
    return {
      galleryIndex: 0,
      fullScreenGalleryIndex: null,
      selectedImage: this.images[0] ?? null,
    }
  },
  computed: {
    appURL: function () {
      return process.env.VUE_APP_URL
    },
    slides: function () {
      return this.images.map((image) => image.imageUrl) ?? []
    },
  },
  methods: {
    gallerySlide(amount) {
      const imageCount = this.images.length

      // Reached end of slides set first slide
      if (this.galleryIndex + amount > imageCount - 1) {
        this.galleryIndex = 0
        this.updateImage()
        return
      }

      // Reached start of slides setting last slide
      if (this.galleryIndex + amount === -1) {
        this.galleryIndex = imageCount - 1
        this.updateImage()
        return
      }

      // In all other scenario's simply add the requested amount
      this.galleryIndex = this.galleryIndex + amount
      this.updateImage()
    },
    updateImage() {
      // Set active image
      this.selectedImage = this.images[this.galleryIndex]
    },
  },
}
</script>
<style lang="scss">
.m-a {
  margin: auto;
}
.mw-350 {
  max-width: 350px;
}
.gallery-controls > div {
  position: absolute;
  top: 25%;
  font-size: 30px;
}

.gallery-image-previous {
  left: 15px;
}
.gallery-image-next {
  right: 15px;
}
</style>
